<div class="layout-topbar" *ngIf="!_router.url.includes('company-detail') && !isFrozenColumn" >
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>
    <div class="layout-topbar-menu mr-4"  (click)="accountMenu.toggle($event)"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <div>
        <p class=" flex align-items-center cursor-pointer profile-image text-username"   *ngIf="!userImage"  >{{userName.charAt(0).toUpperCase()}}</p>
    </div>
        <img class=" flex align-items-center cursor-pointer profile-image" src="{{userImage}}" *ngIf="userImage" >
        &nbsp; 
            <i class="pi pi-angle-down relative top-1"></i> 
        
    </div>
    <p-menu #accountMenu appendTo="body" [popup]="true" [model]="items"></p-menu>
</div>
<div class="layout" *ngIf="isFrozenColumn">
<button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
</button>
</div>


